/**
 * Microsoft OAuth Authentication Form
 */
import React, { useState } from 'react';

const MicrosoftAuthForm = ({ onSuccess, onCancel }) => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authError, setAuthError] = useState(null);

  const handleMicrosoftAuth = async () => {
    setIsAuthenticating(true);
    setAuthError(null);

    const timeoutId = setTimeout(() => {
      console.warn('⚠️ Microsoft auth timeout - resetting authenticating state');
      setIsAuthenticating(false);
      setAuthError('Authentication timed out. Please try again.');
    }, 10000);

    try {
      console.log('⚠️ Microsoft auth disabled for staging');
      throw new Error('Microsoft authentication is disabled');
    } catch (error) {
      clearTimeout(timeoutId);
      console.error('❌ Microsoft OAuth error:', error);
      setAuthError(error.message || 'Authentication failed');
      setIsAuthenticating(false);
    }
  };

  return (
    <div className="text-center py-6">
      <div className="mb-6">
        <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">💼</span>
        </div>
        <h4 className="text-white text-lg font-semibold mb-2">Sign in with Microsoft</h4>
        <p className="text-white/70 text-sm">Use your Microsoft account for enterprise setup</p>
      </div>

      {authError && (
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 mb-4">
          <div className="flex justify-between items-start">
            <p className="text-red-400 text-sm flex-1">❌ {authError}</p>
            <button
              onClick={() => {
                setAuthError(null);
                setIsAuthenticating(false);
              }}
              className="ml-2 text-red-400 hover:text-red-300 text-xs underline"
              title="Clear error and reset"
            >
              Reset
            </button>
          </div>
        </div>
      )}

      <div className="space-y-3">
        <button
          onClick={handleMicrosoftAuth}
          disabled={isAuthenticating}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-blue-600 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 transform hover:scale-105"
        >
          {isAuthenticating ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              <span>Connecting to Microsoft...</span>
            </div>
          ) : (
            <>💼 Continue with Microsoft</>
          )}
        </button>
        
        <button
          onClick={onCancel}
          className="w-full bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors"
        >
          ← Back to Quick Setup
        </button>
      </div>
    </div>
  );
};

export default MicrosoftAuthForm;
